const Map = () => {
    return (
        <div className="m-0 p-0 w-100 mt-5">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2510.8971466619532!2d3.645743515917164!3d50.99957275552599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c37262fca59a31%3A0x33f2c097177009f6!2sVlierstraat%205%2C%209840%20De%20Pinte%2C%20Belgi%C3%AB!5e0!3m2!1snl!2snl!4v1622042733896!5m2!1snl!2snl" width="100%" height="600" style={{border:0}} allowFullScreen={true} loading="lazy"></iframe>
        </div>
    )
}


export default Map